import { openBlock, createBlock, withCtx, createElementVNode, renderSlot, createVNode } from "vue";
import UikitQuestionMarkIcon from "../uikit.icons/QuestionMarkIcon.vue.es.js";
import UikitDropdown from "./Dropdown.vue.es.js";
/* empty css             */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = { class: "help-content" };
const _sfc_main = {
  __name: "Help",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(UikitDropdown, { class: "uikit-help" }, {
        overlay: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ])
        ]),
        default: withCtx(() => [
          createVNode(UikitQuestionMarkIcon, { class: "question-mark-icon u-mr-xs" })
        ]),
        _: 3
      });
    };
  }
};
const UikitHelp = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-80895782"]]);
export {
  UikitHelp as default
};
//# sourceMappingURL=Help.vue.es.js.map
